


























import { Component, Vue } from 'vue-property-decorator'
import { CompanyAPI, MigrationMapAPI } from '@/api/backend-client'

@Component
export default class Pipelines extends Vue {
    migrating: boolean = false
    error: boolean = false

    async startMigration(): Promise<void> {
        this.migrating = true
        this.error = false

        try {
            const migrationMap = (await MigrationMapAPI.getAll({company: this.$currentCompany.id}))[0]
            await MigrationMapAPI.startMigration(migrationMap)
            this.$root.$currentCompany = await CompanyAPI.get(this.$currentCompany.id, true)
        } catch (error) {
            this.error = true
        } finally {
            this.migrating = false
        }
    }
}
